import {Component, EventEmitter, OnInit, Output, ViewEncapsulation} from '@angular/core';
import {CheckboxRadioInputDialogComponent} from './checkbox-radio-input-dialog.component';
import {FieldControlMaster} from '../control-master-label-required';

/**
 * Champs checkbox ou radio
 */
@Component({
  selector: 'app-checkbox-radio-input',
  templateUrl: './checkbox-radio-input.component.html',
  styleUrls: ['./checkbox-radio-input.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class CheckboxRadioInputComponent extends FieldControlMaster implements OnInit {
  @Output() checkboxUpdateControl = new EventEmitter<{ control: any, index: number }>();
  @Output() checkboxDelete = new EventEmitter<number>();
  dialogComponent = CheckboxRadioInputDialogComponent;

  constructor() {
    super();
  }

  ngOnInit(): void {
  }
  onUpdatedControl(object) {
    this.checkboxUpdateControl.emit(object);
  }
  onDeletedControl(index: number) {
    this.checkboxDelete.emit(index);
  }
}
